<div class="flex flex-col p-4 gap-6">
    <div class="flex flex-col gap-4">
      <h2>
        Color Palette
      </h2>
      <div class="flex gap-4">
        <div *ngFor="let colorClass of colorClassList" pTooltip="{{ colorClass }}" class="color-square {{ colorClass }}"></div>
      </div>
      
      <div class="flex gap-4">
        <div *ngFor="let colorClass of severityColorClassList" pTooltip="{{ colorClass }}" class="color-square {{ colorClass }}"></div>
      </div>
    </div>

    <p-divider />

    <div>
      <h2>
        Font
      </h2>
      <div style="font-size: 3rem;">
        {{ selectedFont.name }}
      </div>
    </div>

    <p-divider />

    <div class="flex flex-col gap-2">
      <h2>
        Icons
      </h2>
      @for(iconGroup of iconObjList; track iconGroup) {
        <h2>{{ iconGroup.name }}</h2>
        <div class="flex gap-4 max-w-full flex-wrap mb-4">
          @for(icon of iconGroup.icons; track icon) {
            <div class="flex flex-col gap-1 justify-center items-center">
              <fa-icon [icon]="icon.icon" pTooltip="{{ icon.icon.iconName }}" [showDelay]="200" size="4x"></fa-icon> 
              <div>{{ icon.name }}</div>
            </div>
          }
        </div>
      }
    </div>

    <p-divider />

    <div class="flex flex-col">
        <h2>Buttons</h2>

        <div class="flex gap-2">
            <p-button styleClass="btn btn-primary">Primary</p-button>
            <p-button styleClass="btn btn-secondary">Secondary</p-button>
            <p-button styleClass="btn btn-white">White</p-button>
        </div>
    </div>
    
    <p-divider />

    <div class="flex flex-col">
        <h2>Scrollbars</h2>

        <div class="flex gap-4">
            <p class="w-40 h-40 max-h-40 overflow-auto">Default scrollbar Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            <p class="mini-scrollbar w-40 h-40 max-h-40 overflow-auto">Mini scrollbar Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        </div>
    </div>
    
    <p-divider />

    <div class="flex flex-col gap-4">
        <h2>Form Inputs</h2>

        <div class="flex gap-2">
          <p-checkbox [(ngModel)]="checked" [binary]="true" />
          <label class="flex items-center form-control">
            Checkbox
          </label>
        </div>
        <div class="flex">
          <div class="flex flex-wrap gap-6">
            <div class="flex items-center">
                <p-radiobutton name="radio" value="one" [(ngModel)]="radio" inputId="one" />
                <label for="one" class="ml-2 flex items-center">One</label>
            </div>
        
            <div class="flex items-center">
                <p-radiobutton name="radio" value="two" [(ngModel)]="radio" inputId="two" />
                <label for="two" class="ml-2 flex items-center">Two</label>
            </div>
        
            <div class="flex items-center">
                <p-radiobutton name="radio" value="three" [(ngModel)]="radio" inputId="three" />
                <label for="three" class="ml-2 flex items-center">Three</label>
            </div>
        </div>
        </div>
        <div class="flex items-center">
          <span><p-inputSwitch [(ngModel)]="switchBool" class="flex items-center"></p-inputSwitch></span>
        </div>
        <div class="flex gap-4">
          <input type="text" pInputText placeholder="text box" />
        </div>
        <div>
          <p-select [options]="selectData" [(ngModel)]="selectedOption" optionLabel="value" placeholder="Select an option" />
        </div>
        <div>
          <p-datepicker [(ngModel)]="date" />
        </div>
        <div [formGroup]="form">
          <app-dynamic-form-field className="yer-editor" [field]="editorField" [form]="form" formControlName="editor"></app-dynamic-form-field>
        </div>
    </div>

    <p-divider />

    <div class="flex flex-col gap-2">
      <h2>Dialogs</h2>

      <div>
        <p-button styleClass="btn btn-primary" (click)="confirmDialog($event)" label="Confirm" />
      </div>

      <div>
        <p-button styleClass="btn btn-primary" (click)="showDialog()" label="Dialog" />
        <p-dialog header="Update password" [modal]="true" [(visible)]="dialogVisible" [style]="{ width: '25rem' }">
            <div class="flex items-center gap-6 mb-2">
                <label for="oldPassword" class="font-semibold w-24">Old Password</label>
                <input pInputText type="password" id="oldPassword" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex items-center gap-6 mb-6">
                <label for="newPassword" class="font-semibold w-24">New Password</label>
                <input pInputText type="password" id="newPassword" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex justify-end gap-2">
                <p-button label="Cancel" severity="secondary" (click)="dialogVisible = false" />
                <p-button label="Save" (click)="dialogVisible = false" />
            </div>
        </p-dialog>
      </div>
    </div>

    <p-divider />

    <div class="flex flex-col gap-2">
      <h2>Popover</h2>

      <div>
        <p-button (onClick)="showPopover($event)" styleClass="btn btn-primary">Show More</p-button>
        <p-popover #pop>
          <ng-template #content>
            Show some more details about what's on the page
          </ng-template>
        </p-popover>
      </div>
    </div>

    <p-divider />

    <div class="flex flex-col gap-2">
      <h2>Tooltip</h2>

      <div>
        <p-button styleClass="btn btn-primary" pTooltip="Look at this tooltip with so much helpful information">Hover me</p-button>
      </div>
    </div>

    <p-divider />

    <div class="flex flex-col gap-2">
      <h2>Menus</h2>

      <div>
        <p-button styleClass="btn btn-primary" (click)="menu.toggle($event)">Standard</p-button>
        <p-menu #menu [model]="menuItems" [popup]="true" />
      </div>
    </div>

    <p-divider />

    <div>
      <p-card header="Card" class="flex w-6/12">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque
            quas!
        </p>
      </p-card>
    </div>

    <p-divider />

    <div class="flex flex-col gap-6">
      <h2>
        Table
      </h2>
      <p-table [value]="tableData" [resizableColumns]="true" columnResizeMode="expand" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '50rem'}">
        <ng-template #header>
            <tr>
              <th pResizableColumn>ID</th>
              <th pResizableColumn>Name</th>
              <th pResizableColumn>Numbers</th>
            </tr>
            <tr>
              <th>
                  <p-columnFilter
                      type="text"
                      field="id"
                      placeholder="Search by id"
                      ariaLabel="Filter ID"
                  ></p-columnFilter>
              </th>
              <th>
                  <p-columnFilter
                      type="text"
                      field="name"
                      placeholder="Search by name"
                      ariaLabel="Filter Name"
                  ></p-columnFilter>
              </th>
              <th>
                  <p-columnFilter
                      type="text"
                      field="numbers"
                      placeholder="Search by numbers"
                      ariaLabel="Filter Numbers"
                  ></p-columnFilter>
              </th>
            </tr>
        </ng-template>
        <ng-template #body let-data>
            <tr>
                <td>{{data.id}}</td>
                <td>{{data.name}}</td>
                <td>{{data.numbers}}</td>
            </tr>
        </ng-template>
      </p-table>

      <p-table #dt2 
               dataKey="id"
               [value]="tableData" 
               sortMode="multiple" 
               [resizableColumns]="true" 
               styleClass="p-datatable-gridlines" 
               [globalFilterFields]="['id', 'name', 'numbers']"
               [columns]="columns"
               [tableStyle]="{'min-width': '100%'}">
        <ng-template #caption>
          <app-table-caption [table]="dt2"></app-table-caption>
      </ng-template>
        <ng-template pTemplate="header">
            <tr>
             <app-table-headers [columns]="columns"></app-table-headers>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr>
              <app-table-columns [columns]="columns" [data]="data"></app-table-columns>
            </tr>
        </ng-template>
      </p-table>
    </div>
    
    <p-divider />

    <div>
      <h2>
        Data View
      </h2>
      <p-dataview [value]="dataViewData" [rows]="3" [paginator]="true">
        <ng-template #list let-trips>
            <div class="grid grid-cols-12 gap-4 grid-cols-12 gap-6 grid-nogutter">
                <div class="w-full px-8 col-span-12" *ngFor="let trip of trips; let first = first">
                  <p-divider *ngIf="!first" />
                    <div class="w-full py-8 flex flex-col md:flex-row justify-between items-center flex gap-12">
                        <div class="w-full flex flex-row md:flex-col justify-between items-start gap-2">
                            <div>
                                <span class="font-medium text-secondary text-sm">{{ trip.location }}</span>
                                <div class="font-medium text-secondary text-sm">{{ trip.date }}</div>
                                <div class="text-lg font-medium text-surface-900 dark:text-surface-0 mt-2">{{ trip.group }}</div>
                            </div>
                        </div>
                        <div class="flex flex-col md:items-end">
                          <span class="text-xl font-semibold text-surface-900 dark:text-surface-0">
                            Trip Leader: {{ trip.tl }}</span>
                        </div>
                        <div class="flex flex-col md:items-end gap-20">
                            <div class="flex flex-row-reverse md:flex-row">
                                <p-button
                                    class="flex-auto md:flex-initial whitespace-nowrap"
                                    label="Contact Card"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
      </p-dataview>
    </div>

    <p-divider />

    <div>
      <h2>
        Tabs
      </h2>
      <p-tabs value="0">
          <p-tablist>
              <p-tab value="0">Header I</p-tab>
              <p-tab value="1">Header II</p-tab>
              <p-tab value="2">Header III</p-tab>
          </p-tablist>
          <p-tabpanels>
              <p-tabpanel value="0">
                  <p class="m-0">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                      dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
                      ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                      nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit
                      anim id est laborum.
                  </p>
              </p-tabpanel>
              <p-tabpanel value="1">
                  <p class="m-0">
                      Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem
                      aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
                      Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni
                      dolores eos qui ratione voluptatem sequi nesciunt. Consectetur, adipisci velit, sed quia non numquam eius
                      modi.
                  </p>
              </p-tabpanel>
              <p-tabpanel value="2">
                  <p class="m-0">
                      At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti
                      atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique
                      sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum
                      facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil
                      impedit quo minus.
                  </p>
              </p-tabpanel>
          </p-tabpanels>
      </p-tabs>
    </div>
</div>
